module.exports = __webpack_public_path__ + "static/instruction.85b1dda1.svg";